module.exports = __webpack_public_path__ + "static/img/casino-banner-01.1c3aa18.png";